export const USER = {
  PRACTICE_INDIVIDUAL: 'practise-individual',
  PRACTICE_ADMIN_OWNER: 'practise-admin-owner',
  PRACTICE_ADMIN_ASSOCIATE: 'practise-admin-associate'
};
